"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityViewType = void 0;
exports.instanceOfEntityViewType = instanceOfEntityViewType;
exports.EntityViewTypeFromJSON = EntityViewTypeFromJSON;
exports.EntityViewTypeFromJSONTyped = EntityViewTypeFromJSONTyped;
exports.EntityViewTypeToJSON = EntityViewTypeToJSON;
exports.EntityViewTypeToJSONTyped = EntityViewTypeToJSONTyped;
/**
 *
 * @export
 */
exports.EntityViewType = {
    ShiftViewedByNurse: 'SHIFT_VIEWED_BY_NURSE',
    OrientationOpportunityViewedByNurse: 'ORIENTATION_OPPORTUNITY_VIEWED_BY_NURSE',
    OrientationOpportunityViewedByFacilityAdmin: 'ORIENTATION_OPPORTUNITY_VIEWED_BY_FACILITY_ADMIN'
};
function instanceOfEntityViewType(value) {
    for (const key in exports.EntityViewType) {
        if (Object.prototype.hasOwnProperty.call(exports.EntityViewType, key)) {
            if (exports.EntityViewType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function EntityViewTypeFromJSON(json) {
    return EntityViewTypeFromJSONTyped(json, false);
}
function EntityViewTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function EntityViewTypeToJSON(value) {
    return value;
}
function EntityViewTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=EntityViewType.js.map